import React from 'react';

type ICheckboxGroup = {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string[];
  name?: string;
};

const CheckboxGroupContext = React.createContext<ICheckboxGroup>({});

export default CheckboxGroupContext;

export const useCheckboxGroup = (): ICheckboxGroup =>
  React.useContext(CheckboxGroupContext);
